import MenuIcon from "@material-ui/icons/Menu";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import VideoLibraryIcon from "@material-ui/icons/VideoLibrary";
import HomeIcon from "@material-ui/icons/Home";
import FilterNoneOutlinedIcon from "@material-ui/icons/FilterNoneOutlined";
import { Roles } from "../../../util/PermissionProvider";

const menu = [
  {
    name: "Menu",
    path: "/hknt/menu",
    icon: <MenuIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [
      Roles.SUPERADMIN,
      Roles.HKNT_EDITOR,
      Roles.HKNT_VIEWER,
    ],
  },
  {
    name: "News",
    path: "/hknt/news",
    icon: <InsertDriveFileIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [
      Roles.SUPERADMIN,
      Roles.HKNT_EDITOR,
      Roles.HKNT_VIEWER,
    ],
  },
  {
    name: "Programmes & Periods",
    path: "/hknt/programmes",
    key: "programme",
    icon: <VideoLibraryIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    children: [
      {
        name: "Programmes",
        path: "/hknt/programmes",
      },
      {
        name: "Periods",
        path: "/hknt/period",
      },
    ],
    requiredRoles: [
      Roles.SUPERADMIN,
      Roles.HKNT_EDITOR,
      Roles.HKNT_VIEWER,
    ],
  },
  {
    name: "Homepage",
    path: "/hknt/homepage",
    icon: <HomeIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [
      Roles.SUPERADMIN,
      Roles.HKNT_EDITOR,
      Roles.HKNT_VIEWER,
    ],
  },
  {
    name: "Pages",
    path: "/hknt/pages",
    icon: (
      <FilterNoneOutlinedIcon
        fontSize="small"
        style={{ color: "#BCBCBC", transform: "rotate(90deg)" }}
      />
    ),
    requiredRoles: [
      Roles.SUPERADMIN,
      Roles.HKNT_EDITOR,
      Roles.HKNT_VIEWER,
    ],
  },
];

export default menu;
